import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/product_orders',
  component: Management,
  redirect: '/product_orders/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/product_orders/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listProductOrders
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/product_orders/ListTable'),
          meta: {
            auth: Auth.listProductOrders,
            tabName: 'all'
          }
        },
        {
          path: 'unpaid',
          component: () => import('@/views/product_orders/ListTable'),
          meta: {
            auth: Auth.listProductOrders,
            tabName: 'unpaid'
          }
        },
        {
          path: 'processing',
          component: () => import('@/views/product_orders/ListTable'),
          meta: {
            auth: Auth.listProductOrders,
            tabName: 'processing'
          }
        },
        {
          path: 'unclaimed',
          component: () => import('@/views/product_orders/ListTable'),
          meta: {
            auth: Auth.listProductOrders,
            tabName: 'unclaimed'
          }
        },
        {
          path: 'paid',
          component: () => import('@/views/product_orders/ListTable'),
          meta: {
            auth: Auth.listProductOrders,
            tabName: 'paid'
          }
        },
        {
          path: 'closed',
          component: () => import('@/views/product_orders/ListTable'),
          meta: {
            auth: Auth.listProductOrders,
            tabName: 'closed'
          }
        },
        {
          path: 'complete',
          component: () => import('@/views/product_orders/ListTable'),
          meta: {
            auth: Auth.listProductOrders,
            tabName: 'complete'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/product_orders/DetailLayout'),
      meta: {
        auth: Auth.showProductOrder
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/product_orders/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showProductOrder
          }
        }
      ]
    }
  ]
}
